module.exports = __webpack_public_path__ + "media/images/partner/prevent-bs-14f0a2b7b84b69f8441edc024177b177.jpg";